import { render, staticRenderFns } from "./Editar-enlace.vue?vue&type=template&id=cfd0c668&"
import script from "./Editar-enlace.vue?vue&type=script&lang=js&"
export * from "./Editar-enlace.vue?vue&type=script&lang=js&"
import style0 from "./Editar-enlace.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports